import { render, staticRenderFns } from "./DbpyD.vue?vue&type=template&id=43bb3d8a"
import script from "./DbpyD.vue?vue&type=script&lang=js"
export * from "./DbpyD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports